import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LoadingScreen } from '@/components/LoadingScreen';

// API_URL already includes /api suffix (e.g., https://api.wholeworm.com/api)
const API_URL = import.meta.env.VITE_API_URL || 'https://api.wholeworm.com/api';

export function Connect() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      // No token provided, redirect to settings with error
      navigate('/settings?invite_error=invalid_or_expired', { replace: true });
      return;
    }

    // Redirect to backend accept endpoint which will start Google OAuth
    window.location.href = `${API_URL}/auth/google/accept/${token}`;
  }, [token, navigate]);

  return <LoadingScreen message="Connecting your account..." />;
}
